import { EVAL_PROCESS_STAGES } from './evaluation-process.types.js';
import { isEvalSlotInStage } from './evaluation-process.compute.js';
/** The stages that list the Photos slot (CNC and PLS). */
export const EVAL_PHOTO_STAGES = EVAL_PROCESS_STAGES.filter((stage) => isEvalSlotInStage(stage, 'photos'));
/** The phone page's route, as App.tsx declares it. */
export const EVAL_PHONE_PHOTOS_ROUTE = '/photos/:productId/:stage';
/** The phone page for a product × stage: a short path, no query, so a login's return-to keeps all of it. */
export function evalPhonePhotosPath(productId, stage) {
    return `/photos/${encodeURIComponent(productId)}/${stage}`;
}
/**
 * The phone page for one point's photos (2026-10-14, open question 32): the
 * point dialog's "From phone". A short path, no query, for the same reason.
 */
export const EVAL_POINT_PHONE_PHOTOS_ROUTE = '/photos/point/:productId/:pointId';
/** The phone page for a point's photos. */
export function evalPointPhonePhotosPath(productId, pointId) {
    return `/photos/point/${encodeURIComponent(productId)}/${encodeURIComponent(pointId)}`;
}
//# sourceMappingURL=evaluation-phone-upload.js.map